import { cn } from "@/lib/utils";
import { useOrgModules } from "@/modules/useOrgModules";
import { DashboardInvoicesCard } from "@/modules/dashboard/DashboardInvoicesCard";
import { DashboardLeadsCard } from "@/modules/dashboard/DashboardLeadsCard";
import { DashboardTicketsCard } from "@/modules/dashboard/DashboardTicketsCard";
import { DashboardTodayTasksColumn } from "@/modules/dashboard/DashboardTodayTasksColumn";
import { DashboardWeekCalendar } from "@/modules/dashboard/DashboardWeekCalendar";
import { DashboardWelcomeHeader } from "@/modules/dashboard/DashboardWelcomeHeader";

export const DashboardHomeContent = () => {
  const { isEnabled } = useOrgModules();
  // Widgets of modules the company has on (Apps).
  const cards = [
    isEnabled("pipeline") ? <DashboardLeadsCard key="leads" /> : null,
    isEnabled("invoices") ? <DashboardInvoicesCard key="invoices" /> : null,
    isEnabled("tickets") ? <DashboardTicketsCard key="tickets" /> : null,
  ].filter(Boolean);

  return (
    <div className="mx-auto flex w-full max-w-[1800px] flex-col gap-4 xl:flex-row xl:items-start">
      <div className="flex min-w-0 flex-1 flex-col gap-4">
        <DashboardWelcomeHeader />

        <section className="space-y-4">
          <div>
            <h2 className="text-base font-semibold text-foreground">
              Your work
            </h2>
            <p className="text-sm text-muted-foreground">
              Some items may need a follow-up
            </p>
          </div>

          {cards.length > 0 ? (
            <div
              className={cn(
                "grid gap-4",
                cards.length === 3 && "lg:grid-cols-3",
                cards.length === 2 && "lg:grid-cols-2",
              )}
            >
              {cards}
            </div>
          ) : null}
        </section>

        <div className="xl:hidden">
          <DashboardTodayTasksColumn />
        </div>

        {isEnabled("calendar") ? <DashboardWeekCalendar /> : null}
      </div>

      <aside className="hidden w-full shrink-0 xl:block xl:w-[min(420px,32vw)]">
        <DashboardTodayTasksColumn />
      </aside>
    </div>
  );
};
